import { getResourceStore } from "./crudFactory";

/**
 * 轉派的副作用（ticket 33）。
 *
 * 一次轉派＝一張審核單,單子裡帶著要搬的那批負責關係。關係本身在核准前**不動** ——
 * 送出當下就換人的話,主管退件救不回來(這正是 ticket 30 要處理的老問題)。
 * 所以三個時點各做一件事:
 *   送出   → 每一筆掛上 transfer(誰要接、單號),負責人不變
 *   核准   → 一次把 userId 換掉,transfer 清空
 *   退回   → transfer 清空,其餘原封不動
 */
const relations = () => getResourceStore("work-item");

/** 這張單要搬的關係 id;舊單或格式不符時回空陣列,不要亂搬 */
const itemsOf = (approval) => {
  const ids = approval && approval.payload && approval.payload.items;
  return Array.isArray(ids) ? ids : [];
};

export function applyTransfer(approval, status) {
  if (!approval || approval.action !== "transfer") return;
  const store = relations();
  if (!store) return;

  const toUserId = approval.payload ? approval.payload.toUserId : null;

  itemsOf(approval).forEach((id) => {
    if (status === "approved") {
      store.patch(id, { userId: Number(toUserId), transfer: null });
    } else if (status === "rejected") {
      store.patch(id, { transfer: null });
    } else {
      store.patch(id, {
        transfer: { toUserId: Number(toUserId), docNo: String(approval.id), status: "pending" },
      });
    }
  });
}
